import React from 'react';
import { useAlbumContext } from '@/contexts/AlbumProvider';
import { useLocation } from 'react-router-dom';

const AlbumStatusBar: React.FC = () => {
  const { albumSlug, isActive, isReserved, loading } = useAlbumContext();
  const location = useLocation();

  if (loading) return null;
  if (!albumSlug) return null;

  // Show on album pages that match `/${albumSlug}/*` (slug + at least one segment)
  const path = location.pathname || '';
  const segments = path.split('/').filter(Boolean);
  if (segments[0] !== albumSlug || segments.length < 2) return null;

  // Determine status
  if (isActive) return null; // Active: no bar

  let label: string | null = null;
  if (isReserved && !isActive) label = 'Reservado';
  else if (!isReserved && !isActive) label = 'Inactivo';

  if (!label) return null;

  return (
    <div className="fixed inset-x-0 top-0 z-[70] pointer-events-none">
      <div className="mx-auto max-w-screen-xl">
        <div className="m-2 rounded-md bg-black/70 text-white text-center py-2 backdrop-blur-sm shadow">
          <span className="text-sm font-medium tracking-wide uppercase">{label}</span>
        </div>
      </div>
    </div>
  );
};

export default AlbumStatusBar;
